import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import config from "../config";

const API =
  `${config.API_BASE_URL}/api/categories`;

const AdminCategories = () => {

  const token =
    localStorage.getItem("token");

  // =========================
  // STATES
  // =========================

  const [categories, setCategories] =
    useState([]);

  const [filtered, setFiltered] =
    useState([]);

  const [name, setName] =
    useState("");

  const [search, setSearch] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [editingId, setEditingId] =
    useState(null);

  // =========================
  // LOAD CATEGORIES
  // =========================

  const loadCategories =
    async () => {

    try {

      const res =
        await axios.get(API, {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        });

      const data =
        res.data.data || [];

      setCategories(data);
      setFiltered(data);

    } catch (err) {

      console.error(
        "LOAD CATEGORY ERROR:",
        err
      );
    }
  };

  useEffect(() => {

    loadCategories();

  }, []);

  // =========================
  // SEARCH
  // =========================

  useEffect(() => {

    let data = [...categories];

    if (search.trim()) {

      data = data.filter((c) =>
        (c.name || "")
          .toLowerCase()
          .includes(
            search.toLowerCase()
          )
      );
    }

    setFiltered(data);

  }, [search, categories]);

  // =========================
  // SAVE CATEGORY
  // =========================

  const saveCategory =
    async (e) => {

    e.preventDefault();

    if (!name.trim()) {

      return alert(
        "Enter category name"
      );
    }

    try {

      setLoading(true);

      // =========================
      // UPDATE
      // =========================

      if (editingId) {

        await axios.put(
          `${API}/${editingId}`,
          { name },
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        alert(
          "✅ Category updated"
        );

      } else {

        // =========================
        // ADD
        // =========================

        await axios.post(
          API,
          { name },
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        alert(
          "✅ Category added"
        );
      }

      setName("");
      setEditingId(null);

      loadCategories();

    } catch (err) {

      console.error(
        "SAVE CATEGORY ERROR:",
        err
      );

      alert(
        err.response?.data?.message ||
        "Save failed"
      );

    } finally {

      setLoading(false);
    }
  };

  // =========================
  // EDIT
  // =========================

  const editCategory =
    (cat) => {

    setEditingId(cat.id);

    setName(cat.name);

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  // =========================
  // DELETE
  // =========================

  const deleteCategory =
    async (id) => {

    const ok =
      window.confirm(
        "Delete this category?"
      );

    if (!ok) return;

    try {

      await axios.delete(
        `${API}/${id}`,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      alert(
        "✅ Category deleted"
      );

      loadCategories();

    } catch (err) {

      console.error(
        "DELETE CATEGORY ERROR:",
        err
      );

      alert(
        err.response?.data?.message ||
        "Delete failed"
      );
    }
  };

  // =========================
  // RESET
  // =========================

  const resetForm = () => {

    setName("");
    setEditingId(null);
  };

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <h2 style={styles.title}>
          📂 Category Management
        </h2>

        <p style={styles.subtitle}>
          Add, edit and manage product categories
        </p>

      </div>

      {/* FORM */}

      <div style={styles.card}>

        <form
          onSubmit={saveCategory}
        >

          <div style={styles.formRow}>

            {/* CATEGORY NAME */}

            <div style={styles.inputGroup}>

              <label style={styles.label}>
                Category Name
              </label>

              <input
                type="text"
                placeholder="Enter category name"
                value={name}
                onChange={(e) =>
                  setName(
                    e.target.value
                  )
                }
                style={styles.input}
                required
              />

            </div>

          </div>

          {/* BUTTONS */}

          <div style={styles.btnRow}>

            <button
              type="submit"
              disabled={loading}
              style={styles.saveBtn}
            >

              {loading
                ? "Saving..."
                : editingId
                ? "Update Category"
                : "Add Category"}

            </button>

            {editingId && (

              <button
                type="button"
                onClick={resetForm}
                style={styles.cancelBtn}
              >
                Cancel
              </button>

            )}

          </div>

        </form>

      </div>

      {/* SEARCH */}

      <div style={styles.searchWrap}>

        <input
          type="text"
          placeholder="🔍 Search categories..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
          style={styles.search}
        />

      </div>

      {/* TABLE */}

      <div style={styles.tableCard}>

        <table style={styles.table}>

          <thead>

            <tr>

              <th style={styles.th}>
                ID
              </th>

              <th style={styles.th}>
                Name
              </th>

              <th style={styles.th}>
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {filtered.length === 0 ? (

              <tr>

                <td
                  colSpan="3"
                  style={styles.empty}
                >
                  No categories found
                </td>

              </tr>

            ) : (

              filtered.map((cat) => (

                <tr key={cat.id}>

                  <td style={styles.td}>
                    {cat.id}
                  </td>

                  <td style={styles.td}>
                    {cat.name}
                  </td>

                  <td style={styles.td}>

                    <div style={styles.actionWrap}>

                      <button
                        style={styles.editBtn}
                        onClick={() =>
                          editCategory(cat)
                        }
                      >
                        Edit
                      </button>

                      <button
                        style={styles.deleteBtn}
                        onClick={() =>
                          deleteCategory(
                            cat.id
                          )
                        }
                      >
                        Delete
                      </button>

                    </div>

                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default AdminCategories;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    padding: 20,
    background: "#f4f6f9",
    minHeight: "100vh"
  },

  header: {
    marginBottom: 20
  },

  title: {
    margin: 0,
    fontSize: 28,
    fontWeight: 700
  },

  subtitle: {
    marginTop: 6,
    color: "#666"
  },

  card: {
    background: "#fff",
    borderRadius: 12,
    padding: 20,
    border: "1px solid #e5e7eb",
    marginBottom: 20
  },

  formRow: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(250px,1fr))",
    gap: 20
  },

  inputGroup: {
    display: "flex",
    flexDirection: "column"
  },

  label: {
    marginBottom: 8,
    fontWeight: 600
  },

  input: {
    padding: 12,
    border:
      "1px solid #d1d5db",
    borderRadius: 8,
    fontSize: 14
  },

  btnRow: {
    marginTop: 20,
    display: "flex",
    gap: 10
  },

  saveBtn: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600
  },

  cancelBtn: {
    background: "#6b7280",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: 8,
    cursor: "pointer"
  },

  searchWrap: {
    marginBottom: 20
  },

  search: {
    width: 300,
    maxWidth: "100%",
    padding: 12,
    borderRadius: 8,
    border:
      "1px solid #d1d5db"
  },

  tableCard: {
    background: "#fff",
    borderRadius: 12,
    overflow: "hidden",
    border:
      "1px solid #e5e7eb"
  },

  table: {
    width: "100%",
    borderCollapse:
      "collapse"
  },

  th: {
    textAlign: "left",
    padding: 14,
    background: "#f9fafb",
    borderBottom:
      "1px solid #e5e7eb"
  },

  td: {
    padding: 14,
    borderBottom:
      "1px solid #e5e7eb"
  },

  actionWrap: {
    display: "flex",
    gap: 10
  },

  editBtn: {
    background: "#f59e0b",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: 6,
    cursor: "pointer"
  },

  deleteBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: 6,
    cursor: "pointer"
  },

  empty: {
    textAlign: "center",
    padding: 30,
    color: "#666"
  }
};